import { cn, evaluate, Tooltip } from "@kyan/ui";

import { useMaintenanceAlertController } from "#/hooks/useMaintenanceAlert.controller";
import { useIsDowngradedPerformanceDismissed } from "#/store/app/alerts/isDowngradedPerformanceDismissed";
import { useMarket } from "#/store/app/portfolio/market";
import { useStalePortfolios } from "#/store/wallet/account/stalePortfolios";
import { type PortfolioSymbol } from "#/types/markets";

export const DismissedAlertsDot: React.FC = () => {
  const { market } = useMarket();
  const { stalePortfolios, shouldFetchAccountState } = useStalePortfolios();
  const { isDowngradedPerformanceDismissed } =
    useIsDowngradedPerformanceDismissed();
  const { isMaintenanceActive, description, isMaintenanceAlertDismissed } =
    useMaintenanceAlertController();

  const shouldShowDowngradedPerformanceDot =
    shouldFetchAccountState &&
    isDowngradedPerformanceDismissed &&
    stalePortfolios.includes(market.underlying as PortfolioSymbol);

  const shouldShowMaintenanceAlertDot =
    isMaintenanceActive && isMaintenanceAlertDismissed;

  const shouldShowDot =
    shouldShowDowngradedPerformanceDot || shouldShowMaintenanceAlertDot;

  const content = evaluate({
    [description]: shouldShowMaintenanceAlertDot,
    "Updating account state data every ~10 seconds.":
      shouldShowDowngradedPerformanceDot,
  });

  return (
    <Tooltip content={content} disabled={!shouldShowDot}>
      <div className="absolute -top-1.5 -right-2.5 flex size-2.5 items-center justify-center rounded-full">
        <div
          className={cn(
            "bg-notice size-1 rounded-full opacity-0 transition-opacity",
            {
              "opacity-100": shouldShowDot,
            },
          )}
        />
      </div>
    </Tooltip>
  );
};
